/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1AssociatedcompanyTotalEmployeesDropdown200,
  GetApiV1AssociatedcompanyTotalEmployeesDropdown401,
  GetApiV1AssociatedcompanyTotalEmployeesDropdown500,
  GetApiV1AssociatedcompanyTotalEmployeesDropdownQueryResponse,
} from "../../types/associatedCompanySharedController/GetApiV1AssociatedcompanyTotalEmployeesDropdown.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1AssociatedcompanyTotalEmployeesDropdown200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1AssociatedcompanyTotalEmployeesDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1AssociatedcompanyTotalEmployeesDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1AssociatedcompanyTotalEmployeesDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1AssociatedcompanyTotalEmployeesDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1AssociatedcompanyTotalEmployeesDropdown500>;

export const getApiV1AssociatedcompanyTotalEmployeesDropdownQueryResponseSchema =
  z.lazy(
    () => getApiV1AssociatedcompanyTotalEmployeesDropdown200Schema,
  ) as unknown as ToZod<GetApiV1AssociatedcompanyTotalEmployeesDropdownQueryResponse>;
